import React, { useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    description: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");
    setMessageType("");

    try {
      // EmailJS configuration - Replace with your actual values
      // Get these from https://www.emailjs.com/
      const serviceID = "service_or8i3c7"; // Replace with your Service ID
      const templateID = "template_ykbh7ep"; // Replace with your Template ID
      const publicKey = "gJCVxP7dQjZdVFySE"; // Replace with your Public Key

      // Template parameters for EmailJS
      // Make sure your EmailJS template includes these variables:
      // {{from_name}}, {{from_email}}, {{message}}, {{to_name}}, {{to_email}}
      const templateParams = {
        from_name: formData.fullName,
        from_email: formData.email,
        message: formData.description,
        to_name: "Scout Minion Team",
        to_email: "belal.nayeem1@gmail.com",
      };

      const response = await emailjs.send(
        serviceID,
        templateID,
        templateParams,
        publicKey
      );

      if (response.status === 200) {
        setMessage(
          `Thank you for your message! I'll get back to you soon.\n\nThank you for reaching out!\nWe truly value your message and are here to help. Our team will respond to you shortly.`
        );
        setMessageType("success");
        setFormData({
          fullName: "",
          email: "",
          description: "",
        });
      } else {
        throw new Error("Failed to send message");
      }
    } catch (error) {
      console.error("EmailJS Error:", error);
      setMessage(
        "Sorry, there was an error sending your message. Please try again."
      );
      setMessageType("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container">
      <div className="contact-form">
        <h1>Contact Us</h1>
        <p>
          At Scout Minion, we strive to provide the best service possible.
          Please fill out the form, and our team will get back to you shortly.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="fullName">Full Name</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description of Problem</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Please describe your issue or inquiry..."
              required
            />
          </div>

          <button type="submit" className="submit-btn" disabled={isSubmitting}>
            {isSubmitting ? "Sending..." : "Submit"}
          </button>

          {message && (
            <div
              className={
                messageType === "success" ? "success-message" : "error-message"
              }
            >
              {message}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
